export default "<video class=\"c-responsive-video__video\" preload=\"none\" playsinline loop muted autoplay>{{ sources }}</video>\n"